import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import {
  contentHeight100,
  contentStyle,
  contentStyle150,
  dataDispWidth,
  labelStyle,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';
import EqTrouble from '../../models/data/EqTrouble';
import dateRange from '../date-range';

interface DataProps {
  userdata: AuthenticatedContextType;
  data: EqTrouble | undefined;
}

const DataDisp: React.FC<DataProps> = ({ userdata, data }) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  return (
    <div>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={1}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.userInfo }}
      >
        <Descriptions.Item label="ユーザ名" span={1}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      {/* ID */}
      <Descriptions
        bordered
        column={3}
        contentStyle={contentStyle150}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.eqMaintBase }}
      >
        <Descriptions.Item label="顧客設備ID" span={1}>
          {data?.trEqCustEqId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="設備修理ID" span={1}>
          {data?.troubleEqId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="工号" span={1}>
          {data?.trEqJobNo ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="修理期間" span={3}>
          {dateRange(data?.trEqStartDate, data?.trEqStartDate)}
        </Descriptions.Item>
      </Descriptions>
      {/* 故障修理詳細 */}
      <Descriptions
        bordered
        column={2}
        contentStyle={contentStyle150}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.eqTroubleDetail }}
      >
        <Descriptions.Item
          label="修理内容"
          span={2}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.trEqSummary ?? ''}
        </Descriptions.Item>
        <Descriptions.Item
          label="不具合 機器型式"
          span={2}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.trEqDevice ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="対応者" span={2}>
          {data?.trEqName ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="報告書番号" span={2}>
          {data?.trEqReportNo ?? ''}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
